// import TextToSpeech from '../../TextToSpeech/textToSpeech';
// import Counter from '../../components/Counter/Counter';
import ArttuImage from "../../assets/arttu2.webp";
import { FaLinkedin, FaInstagram, FaFacebook, FaTiktok } from "react-icons/fa";
import { MdOutlineMail, MdPhone, MdAccessTime } from "react-icons/md";
import { useEffect, useRef } from "react";

const teamMembers = [
  {
    name: "Arttu Stenius",
    role: "Yrittäjä | Perustaja",
    image: ArttuImage,
    description: (
      <>
        Moi! Olen Arttu, Spiderlegs Productionsin perustaja. Rumpalina olen
        esiintynyt eri bändeissä 90-luvun alusta lähtien, ja vuosien varrella
        kertynyt kokemus on opettanut paljon tapahtumatekniikasta,
        äänentoistosta ja live-tilanteiden käytännön tarpeista – sekä lavalla
        että sen takana.
        <br />
        <br />
        Spiderlegs Productions syntyi käytännön tarpeesta: halusin tehdä
        tapahtumatekniikan ja äänentoiston vuokraamisesta selkeää, helppoa ja
        luotettavaa. Kokemus muusikkona ja tekniikan käyttäjänä on muovannut
        tapaani rakentaa palvelua asiakkaan näkökulmasta – tekniikan pitää
        toimia, jotta tilaisuus voi onnistua.
        <br />
        <br />
        Palveluihimme kuuluu äänentoiston, valotekniikan ja esitystekniikan
        vuokraus sekä tarvittaessa kuljetus, asennus ja opastus laitteiden
        käyttöön. Tarjoamme myös peräkärryn vuokrausta, joka toimii saman
        selkeän ja helppokäyttöisen järjestelmän kautta.
        <br />
        <br />
        Toimintamme on joustavaa ja asiakaslähtöistä. Oli kyseessä sitten
        kotijuhlat, häät, kokous tai yritystilaisuus, saat meiltä toimivat
        tekniset ratkaisut ilman turhaa monimutkaisuutta. Ja jos tarvitset
        apua, saat nopeaa ja henkilökohtaista palvelua suoraan minulta.
      </>
    ),
  },
];

const socialLinks = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/spiderlegsproductions/",
    icon: FaFacebook,
    eventChannel: "facebook",
    title: "Seuraa Facebookissa",
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/spiderlegsproductions/",
    icon: FaInstagram,
    eventChannel: "instagram",
    title: "Seuraa Instagramissa",
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/in/spiderlegs-productions/",
    icon: FaLinkedin,
    eventChannel: "linkedin",
    title: "Seuraa LinkedInissä",
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@spiderlegsproductions",
    icon: FaTiktok,
    eventChannel: "tiktok",
    title: "Seuraa TikTokissa",
  },
];

const trackTeamEvent = (eventName, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, {
      sijainti: "team_osio",
      ...params,
    });
  }
};

const textClass =
  "font-customFont1 text-lg leading-relaxed !text-[#374151] dark:!text-[#D1D5DB]";

const headingClass =
  "font-customFont2 text-4xl font-bold uppercase leading-none !text-[#111827] dark:!text-white sm:text-5xl";

const cardClass =
  "rounded-[2rem] border border-[#DDE7E5] bg-white/90 p-6 shadow-xl backdrop-blur-xl dark:border-darkborder dark:bg-[#111114]/95 sm:p-8";

const Team = () => {
  const sectionRef = useRef(null);
  const member = teamMembers[0];

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trackTeamEvent("osio_nakyvissa", {
              osio: "team",
            });

            // Vain kerran
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="team-section py-4">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.15fr_0.85fr]">
        {/* Sinua palvelee */}
        <article className={cardClass}>
          <div className="flex flex-col gap-8 xl:flex-row xl:items-start">
            <div className="shrink-0 text-center">
              <div
                className="
                  mx-auto mb-5 flex h-64 w-64 items-center justify-center
                  rounded-full border border-primary/30 bg-primary/10 p-2 shadow-inner
                  dark:border-primary/30 dark:bg-primary/5
                "
              >
                <img
                  src={member.image}
                  alt={`${member.name} kuva`}
                  loading="lazy"
                  className="
                    h-full w-full rounded-full object-cover object-top
                    ring-4 ring-white dark:ring-[#111114]
                  "
                />
              </div>

              <h3 className="font-customFont1 text-2xl font-extrabold !text-[#111827] dark:!text-white">
                {member.name}
              </h3>

              <p className="mt-1 font-customFont1 text-base font-semibold !text-[#4B5563] dark:!text-[#D1D5DB]">
                {member.role}
              </p>
            </div>

            <div>
              <span
                className="
                  mb-4 inline-flex rounded-full border border-primary/40 bg-primary/10
                  px-4 py-1.5 font-customFont1 text-xs font-extrabold uppercase
                  tracking-[0.14em] !text-[#111827] shadow-sm
                  dark:!text-white
                "
              >
                Sinua palvelee
              </span>

              <h2 className={headingClass}>Kokemusta lavalta ja tekniikasta</h2>

              <p className={`${textClass} mt-6`}>{member.description}</p>
            </div>
          </div>
        </article>

        {/* Yhteystiedot */}
        <aside
          className="
            rounded-[2rem] border border-primary/30 bg-primary/10 p-6 shadow-xl
            dark:border-primary/30 dark:bg-primary/5 dark:shadow-none
            sm:p-8
          "
        >
          <span
            className="
              mb-4 inline-flex rounded-full border border-primary/40 bg-white
              px-3 py-1 font-customFont1 text-xs font-extrabold uppercase
              tracking-[0.12em] !text-[#111827]
              dark:bg-darksurface dark:!text-white
            "
          >
            Ota yhteyttä
          </span>

          <h2 className={headingClass}>Yhteystiedot</h2>

          <div className="mt-7 space-y-4">
            <div
              className="
                rounded-2xl border border-[#DDE7E5] bg-white/75 p-4 shadow-sm
                dark:border-darkborder dark:bg-[#111114]/70
              "
            >
              <div className="flex items-start gap-3">
                <MdOutlineMail
                  className="mt-1 shrink-0 text-primary"
                  size={22}
                />

                <div>
                  <p className="font-customFont1 text-sm font-extrabold uppercase tracking-[0.1em] !text-[#4B5563] dark:!text-[#D1D5DB]">
                    Sähköposti
                  </p>

                  <a
                    href="mailto:info@spiderlegsproductions.com"
                    className="
                      mt-1 inline-block break-all font-customFont1 text-base font-extrabold
                      !text-[#111827] underline decoration-primary decoration-2 underline-offset-4
                      transition hover:!text-primary
                      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary
                      focus-visible:ring-offset-2 focus-visible:ring-offset-white
                      dark:!text-white dark:hover:!text-primary dark:focus-visible:ring-offset-[#111114]
                    "
                    aria-label="Lähetä sähköposti Spiderlegs Productionsille"
                    onClick={() =>
                      trackTeamEvent("email_klikattu", {
                        kohde: "info@spiderlegsproductions.com",
                      })
                    }
                  >
                    info@spiderlegsproductions.com
                  </a>
                </div>
              </div>
            </div>

            <div
              className="
                rounded-2xl border border-[#DDE7E5] bg-white/75 p-4 shadow-sm
                dark:border-darkborder dark:bg-[#111114]/70
              "
            >
              <div className="flex items-start gap-3">
                <MdPhone className="mt-1 shrink-0 text-primary" size={22} />

                <div>
                  <p className="font-customFont1 text-sm font-extrabold uppercase tracking-[0.1em] !text-[#4B5563] dark:!text-[#D1D5DB]">
                    Puhelin
                  </p>

                  <a
                    href="tel:+358443519265"
                    className="
                      mt-1 inline-block font-customFont1 text-base font-extrabold
                      !text-[#111827] transition hover:!text-primary
                      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary
                      focus-visible:ring-offset-2 focus-visible:ring-offset-white
                      dark:!text-white dark:hover:!text-primary dark:focus-visible:ring-offset-[#111114]
                    "
                    aria-label="Soita Spiderlegs Productionsille"
                    onClick={() =>
                      trackTeamEvent("puhelin_klikattu", {
                        numero: "+358443519265",
                      })
                    }
                  >
                    +358 44 351 92 65
                  </a>
                </div>
              </div>
            </div>

            <div
              className="
                rounded-2xl border border-[#DDE7E5] bg-white/75 p-4 shadow-sm
                dark:border-darkborder dark:bg-[#111114]/70
              "
            >
              <div className="flex items-start gap-3">
                <MdAccessTime
                  className="mt-1 shrink-0 text-primary"
                  size={22}
                />

                <div>
                  <p className="font-customFont1 text-sm font-extrabold uppercase tracking-[0.1em] !text-[#4B5563] dark:!text-[#D1D5DB]">
                    Aukioloajat
                  </p>

                  <p className="mt-1 font-customFont1 text-base font-semibold leading-relaxed !text-[#111827] dark:!text-white">
                    Ma–Pe: 8:00–18:00, La: 10:00–17:00.
                    <br />
                    Myös joustavasti sopimuksen mukaan.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p
            className="
              mt-7 rounded-2xl border border-primary/30 bg-white/70 p-4
              font-customFont1 text-base font-bold leading-relaxed
              !text-[#111827]
              dark:bg-[#111114]/70 dark:!text-white
            "
          >
            Ota rohkeasti yhteyttä – vastaamme nopeasti ja autamme
            tapahtumatekniikan, laitevuokrauksen, kuljetuksen ja asennuksen
            kysymyksissä.
          </p>

          {/* <div className="flex flex-col items-center mt-10">
            <Counter end={36} label="Toteutettua vuokrausprojektia" />
            <Counter end={324} label="Tyytyväistä asiakasta" />
            <Counter end={12} label="Tapahtumaa vuodessa" />
          </div> */}

          <div className="mt-10 text-center">
            <p className="font-customFont1 text-sm font-extrabold uppercase tracking-[0.12em] !text-[#111827] dark:!text-white">
              Seuraa somessa
            </p>

            <div className="mt-5 flex justify-center gap-3">
              {socialLinks.map((social) => {
                const Icon = social.icon;

                return (
                  <a
                    key={social.name}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Spiderlegs Productions ${social.name}`}
                    title={social.title}
                    onClick={() =>
                      trackTeamEvent("some_klikattu", {
                        kanava: social.eventChannel,
                      })
                    }
                    className="
                      flex h-11 w-11 items-center justify-center rounded-full
                      border border-[#DDE7E5] bg-white
                      !text-[#111827] shadow-sm
                      transition duration-200
                      hover:-translate-y-0.5 hover:border-primary hover:bg-primary hover:!text-[#111827] hover:shadow-md
                      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary
                      focus-visible:ring-offset-2 focus-visible:ring-offset-white
                      dark:border-darkborder dark:bg-darksurface dark:!text-white
                      dark:hover:border-primary dark:hover:bg-primary dark:hover:!text-[#111827]
                      dark:focus-visible:ring-offset-[#111114]
                    "
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
};

export default Team;